var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table-view',{attrs:{"scrId":_vm.scrId}})
}
var staticRenderFns = []

export { render, staticRenderFns }